import axios from "axios";
import toast from "react-hot-toast";

const AxiosInstance = axios.create({
    baseURL: process.env.BASE_URL,
});

const API_STATUS_CODES = {
    SUCCESS: process.env.REACT_APP_STATUS_SUCCESS || 200,
    UNAUTHORIZED: process.env.REACT_APP_STATUS_FORBIDDEN || 401,
    BAD_REQUEST: 400, // Added 400 status code
};

AxiosInstance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem("accessToken");
        if (token && config.headers) {
            config.headers['Authorization'] = `Bearer ${token}`;
            config.headers['Auth-Token'] = `Bearer ${token}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

AxiosInstance.interceptors.response.use(
    (response) => {
        // If the API returns a success code inside the data body
        if (response?.data?.statusCode === parseInt(API_STATUS_CODES.SUCCESS)) {
            return response;
        }
        return Promise.reject(response);
    },
    (error) => {


        const statusCode = error?.response?.status || error?.response?.data?.statusCode;
        const errorMessage = error?.response?.data?.message || "Something went wrong";

        console.log(statusCode ,errorMessage)
        // Handle 401 Unauthorized
        if (parseInt(statusCode) === parseInt(API_STATUS_CODES.UNAUTHORIZED)) {
            toast.error(errorMessage);
            // Optional: localStorage.clear(); window.location.href = '/login';
        }

        // --- NEW: Handle 400 Bad Request ---
        if (parseInt(statusCode) === parseInt(API_STATUS_CODES.BAD_REQUEST)) {
            toast.error(errorMessage);
        }

        return Promise.reject(error);
    }
);

export default AxiosInstance;